import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/attritionAndCancelReasonsSaga";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { SingleDatePicker } from "./smartComponents/SingleDatePicker";
import { MembershipTypes } from "./smartComponents/MembershipTypes";
import { DataPoints } from "./smartComponents/DataPoints";
import { YearOverYearChart } from "./smartComponents/YearOverYearChart";
import PieCharts from "./smartComponents/PieCharts";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import ViewFilter from "./smartComponents/ViewFilter";

import NoData from "../../../components/noData/noData";
import "./styles.scss";

export const AttritionAndCancelReasonsModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.attritionAndCancelReasons.isLoading);
  const initialRequest = useSelector((state) => state.attritionAndCancelReasons.initialRequest);
  const updatesLoading = useSelector((state) => state.attritionAndCancelReasons.updatesLoading);
  const membershipTypes = useSelector(
    (state) => state.attritionAndCancelReasons.selectedFilters.membership_types
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <SectionToggle
      autoHeight
      isLoading={isLoading}
      title="Attrition & Cancel Reasons"
      learnMore={
        <>
          <KBLearnMore {...learnMoreProps()} />
          <ViewFilter />
        </>
      }
      content={
        <div id="attritionAndCancelReasonsModule">
          <div id="module-date-filters">
            {membershipTypes.length ? (
              <div id="override-edit-selection-bar" className="edit-selections-bar">
                <div className="section">
                  <div className="filters-wrapper">
                    <div>
                      <MembershipTypes />
                    </div>
                    <SingleDatePicker />
                    <UpdateBtns />
                  </div>
                </div>

                {updatesLoading ? (
                  <LoadingAnimation text="Updating data..." />
                ) : (
                  <>
                    <div className="section">
                      <DataPoints />

                      <YearOverYearChart />
                    </div>
                    <div className="section">
                      <PieCharts />
                    </div>
                  </>
                )}
              </div>
            ) : (
              <NoData />
            )}
          </div>
        </div>
      }
    />
  );
};

const learnMoreProps = () => ({
  title: "Attrition & Cancel Reasons",
  description:
    "This report shows detailed cancellation reasons across your selected timeframe, giving you visibility into why members choose to leave. These insights help you identify trends, address root\u2011cause issues, and strengthen retention strategies.",
  kbUrl: ILEARN_URLS.membership.attritionAndCancelReasons
});
